var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfiniteMeetingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.924,
    height: 45.924,
    viewBox: "0 0 45.924 45.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-554.315 -386.29)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(554.315 386.29)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.962,
    cy: 22.962,
    r: 22.962,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.962,
    cy: 22.962,
    r: 22.462,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.176,15.324H5.96a.851.851,0,0,1-.852-.85H.852A.852.852,0,0,1,0,13.622a4.257,4.257,0,0,1,6.862-3.363,6.008,6.008,0,0,1,8.452,0,4.257,4.257,0,0,1,6.862,3.363.852.852,0,0,1-.852.852H17.067a.851.851,0,0,1-.851.85ZM15.365,5.96a2.554,2.554,0,1,1,2.554,2.553A2.554,2.554,0,0,1,15.365,5.96ZM1.7,5.96A2.554,2.554,0,1,1,4.257,8.513,2.554,2.554,0,0,1,1.7,5.96Zm9.385.851h-.02a3.405,3.405,0,1,1,0-6.811h.04a3.405,3.405,0,0,1,0,6.811Z",
    transform: "translate(566.538 401.278)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiniteMeetingIcon);
export default __webpack_public_path__ + "static/media/infiniteMeetingIcon.34c36a303edfa194e701ee7d1df9895b.svg";
export { ForwardRef as ReactComponent };